import React from 'react';
import Button from '../ui/Button.jsx';

export default function OptionGrid({ label, value, options, onChange, columns = 2 }) {
  return (
    <div className="space-y-2">
      <div className="text-sm font-semibold text-ptcm-ink dark:text-gray-100">{label}</div>
      <div className={`grid gap-2 ${columns === 3 ? 'grid-cols-3' : 'grid-cols-2'}`}>
        {options.map((opt) => {
          const selected = value === opt.value;
          return (
            <Button
              key={opt.value}
              type="button"
              variant={selected ? 'secondary' : 'outline'}
              className="h-auto py-3 px-3 text-left justify-start leading-snug"
              onClick={() => onChange(opt.value)}
            >
              <span className="text-sm">{opt.label}</span>
            </Button>
          );
        })}
      </div>
    </div>
  );
}

